<template>
  <v-text-field
    ref="searchField"
    single-line
    hide-details
    class="searchField mx-4 my-0 py-0 px-2"
    clearable
    v-model="search"
  >
    <template v-slot:prepend-inner>
      <v-img
        class="mx-2 searchIcon"
        small
        src="@/assets/images/bars-search-bar-x-search-glyph-light@3x.png"
      />
    </template>
    <template v-slot:label>
      <div style="padding-top: 2px">Search</div>
    </template>
  </v-text-field>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SearchBar',
  props: {
    debounce: {
      type: Number,
      default: 500,
    },
  },
  data: () => ({
    search: '',
    timeout: null,
  }),
  computed: {
    ...mapGetters(['searchText']),
  },
  methods: {
    ...mapActions(['searchForText']),
  },
  watch: {
    searchText(newVal) {
      if (newVal !== this.search) {
        this.search = newVal
      }
    },
    search(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.timeout) {
          clearTimeout(this.timeout)
        }
        this.timeout = setTimeout(() => {
          this.searchForText(newVal)
        }, this.debounce)
      }
    },
  },
}
</script>

<style lang="sass">
.searchField
  background-color: $background
  max-width: 388px
  height: 36px

.searchField.v-text-field>.v-input__control>.v-input__slot:before
  border-style: none !important

.searchIcon
  margin-top: 3px
  margin-bottom: 3px
  width: 24px
  height: 22px
</style>
